import React from 'react';
import { YoutubePlayer, YoutubePlayerProps } from '../YouTubePlayer/YouTubePlayer';
import { useStackVideoPlayerContext } from '../hooks/useStackVideoPlayer';

export type StackYoutubePlayerProps = YoutubePlayerProps;
// StackYoutubePlayer required to support multiple video players on a single view and to control playback via external controls
export const StackYoutubePlayer = (props: YoutubePlayerProps) => {
  const { addPlayer } = useStackVideoPlayerContext();

  const handleAddPlayer: StackYoutubePlayerProps['onPlayerLoaded'] = player => {
    addPlayer?.(player);
    props.onPlayerLoaded?.(player);
  };
  return <YoutubePlayer {...props} onPlayerLoaded={handleAddPlayer} />;
};
